import React from 'react';
import ReactDOM from 'react-dom';
import './assets/CSS/style.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './Language/i18n';//For language conversion option
//var type = sessionStorage.getItem("language") !== null ? sessionStorage.getItem("language") : "ltr";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
//document.getElementsByTagName('html')[0].setAttribute("dir", type);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
